export const isTimeRangeFlexibilityEditable = (obj: {
  flexibilityConstraints: { allowedToModify: boolean | null } | null;
}) => !!(obj.flexibilityConstraints && obj.flexibilityConstraints.allowedToModify);

export default isTimeRangeFlexibilityEditable;
